export default __webpack_public_path__ + "static/media/Marca_Chile.ca7438f0.svg";